<template>
    <v-card flat>
        <v-card-title>
            {{ name }}
            <v-spacer></v-spacer>
            <v-btn
                dark
                color="primary"
                class="mb-2"
                :to="{ name: newItemRouteName, params: { requesterType: $route.meta.requesterType, requesterId: this.id, activeTab: activeTab } }"
            >
                <v-icon>add</v-icon> {{ $t('client.contracts.addItem') }}
            </v-btn>
        </v-card-title>

        <v-tabs
            ref="tabs"
            v-model="activeTab"
            background-color="white"
            color="primary"
            centered
        >
            <v-tab v-for="tab of tabs" :key="tab.id" :to="tab.route" @change="setTabActive(tab.id)" exact>
                {{ tab.name }}
            </v-tab>

            <v-tabs-items v-model="activeTab">
                <router-view></router-view>
            </v-tabs-items>
        </v-tabs>
    </v-card>
</template>

<script>
import API from '@/api'

export default {
    name: 'detail-tab-contract',
    props: ['id'],
    data: function () {
        return {
            name: '',
            activeTabId: 1,
            activeTab: `${this.$route.meta.requesterType}/detalhe/${this.id}/contratos/ativos`,
            tabs: [
                { id: 1, name: this.$t('client.contracts.tabs.active'), route: `${this.$route.meta.basePath}/detalhe/${this.id}/contratos/ativos` },
                { id: 2, name: this.$t('client.contracts.tabs.inactive'), route: `${this.$route.meta.basePath}/detalhe/${this.id}/contratos/inativos` }
            ]
        }
    },
    watch: {
        '$route': {
            handler: function (val, oldVal) {
                if (oldVal !== val) {
                    this.activeTab = `${this.$route.meta.requesterType}/detalhe/${this.id}/contratos/ativos`
                    this.tabs = [
                        { id: 1, name: this.$t('client.contracts.tabs.active'), route: `${this.$route.meta.basePath}/detalhe/${this.id}/contratos/ativos` },
                        { id: 2, name: this.$t('client.contracts.tabs.inactive'), route: `${this.$route.meta.basePath}/detalhe/${this.id}/contratos/inativos` }
                    ]
                    this.$refs.tabs.callSlider()
                    this.loadData()
                }
            },
            deep: true
        }
    },
    mounted () {
        this.loadData()
    },
    computed: {
        newItemRouteName () {
            let routes = {
                1: `CadastrarContrato${this.$route.meta.singleName}AA`,
                2: `CadastrarContrato${this.$route.meta.singleName}BB`
            }
            return routes[this.activeTabId]
        }
    },
    methods: {
        setTabActive (index) {
            this.activeTabId = index
        },
        loadData () {
            this.loading = true
            window.getApp.disableClientNavigation = true
            let endpoint = API.EndPoints.getClient
            let params = {
                objectId: (this.$route.params.requesterId !== undefined) ? this.$route.params.requesterId : this.$route.params.id
            }
            new API(endpoint, params).request().then(response => {
                this.name = response.data.result.name
                window.getApp.disableClientNavigation = false
            }, (e) => {
                this.$helpers.requestError(e)
            })
        }
    }
}
</script>
